var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center",staticStyle:{"z-index":"9999","position":"fixed"}},[_c('v-overlay',{staticStyle:{"z-index":"9999"},attrs:{"value":_vm.$store.state.loader}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":"64"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }